import { FC, useCallback, useEffect, useState } from 'react';

import Accordion from '@/components/accordion';
import Typography from '@/components/typography';
import { County, getCounties } from '@/endpoints/itasca/county/getCounties';
import { State } from '@/endpoints/itasca/state/getState';

type Props = {
  state: State;
};

export const StateAccordian: FC<Props> = ({ state }) => {
  const [counties, setCounties] = useState<County[]>([]);
  const [isOpen, setIsOpen] = useState(false);

  const fetchCounties = useCallback(async () => {
    const { res } = await getCounties({
      params: {
        include__geometry: false,
        limit: 300,
        offset: 0,
        ordering: 'full_name',
        state_fips: state?.state_fips!,
      },
    });

    setCounties(res?.data.results || []);
  }, [state?.state_fips]);

  useEffect(() => {
    fetchCounties();
  }, [fetchCounties]);
  return (
    <Accordion
      className="w-full border-t-0 text-black"
      startOpened={isOpen}
      summary={
        <div className="flex flex-wrap gap-x-2 gap-y-1">
          {counties.map((county: County) => {
            return (
              <Typography
                key={county.full_fips}
                className="word-wrap: break-word;"
              >
                <a
                  className="text-green-50 underline hover:text-green-60"
                  href={`/plat-map/map/${county.state_abbrev.toLowerCase()}/${
                    county.county_state_slug
                  }`}
                >
                  {county.full_name}
                </a>
              </Typography>
            );
          })}
        </div>
      }
      title={state.name}
      titleClassName="text-black"
      onClick={() => setIsOpen(!isOpen)}
    />
  );
};
